import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { RoleFormComponent } from './components/role-form/role-form.component';

@NgModule({
  declarations: [
    RoleFormComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    SharedModule,
    RouterModule,
  ],
  exports: [
    RoleFormComponent,
  ],
})
export class RoleModule {
}
